import { IController } from 'angular';
import * as _ from 'lodash';

import { Cohort } from '../../../../../../../ng2/shared/constants/cohort.constant';
import { GraduationPlan as Plan } from '../../../../../../../ng2/shared/constants/graduation-plan.constant';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class RegentsAssignmentAugCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  private activeStudentsByCohort;
  private filteredStudentsByGp;
  private superSeniorThreshold;
  public currentCohortFilter: string;
  public sort: string;
  public explainer: string;

  // studentIds: wizard-action-filter:
  public studentIdsWithCalcGpRegents: string[];
  public studentIdsWithCurrGpIncomplete: string[];
  public studentIdsWithCurrGpOther: string[];
  public studentIdsWithCurrGpRegents: string[];

  // _ids: to generate patches
  private _idsWithCalcRegents;

  // misc
  public filterOptions;
  public textOptions;
  public allEligibleStudentPatches;

  // disable btns after user action
  public actionTaken: boolean;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filterOptions = {
      columnKeys: ['gradPlan', 'plannedDiplomaType', 'plannedGraduationDate'],
      sort: [{ colId: 'countOfRegentsPassedAt65Of5', sort: 'desc' }],
    };

    this.superSeniorThreshold = _.find(Cohort, { studentYear: 4 }).value;
    this.currentCohortFilter = _.last(this.WizardUtils.getCurrentCohortFilter());
    this.explainer = this.WizardUtils.getGradPlanThresholdExplainer('Regents', 'Aug');
    this.activeStudentsByCohort = this.WizardUtils.getFilteredFlattenedStudents({
      status: ['A', 'A-NDG'],
      cohort: [this.currentCohortFilter],
    });

    this.textOptions = { gradDate: `Aug ${this.currentCohortFilter}`, diplomaType: 'Regents' };

    // bucketed students:
    this.filteredStudentsByGp = this.generateFilteredStudentIdBuckets();

    // studentIds[] : to generate filter for grid
    this.studentIdsWithCalcGpRegents = _.keys(this.filteredStudentsByGp.calculatedGpRegents);
    this.studentIdsWithCurrGpRegents = _.keys(this.filteredStudentsByGp.currentGpRegents);
    this.studentIdsWithCurrGpIncomplete = _.keys(this.filteredStudentsByGp.currentGpIncomplete);
    this.studentIdsWithCurrGpOther = _.keys(this.filteredStudentsByGp.currentGpOther);

    // student_ids[] : to patch students
    this._idsWithCalcRegents = _.values(this.filteredStudentsByGp.calculatedGpRegents);

    const diffs = _.difference(this._idsWithCalcRegents, _.values(this.filteredStudentsByGp.currentGpRegents));
    this.allEligibleStudentPatches = this.WizardUtils.getGradPlanningBulkPatch(
      diffs,
      this.textOptions.gradDate,
      'Regents',
    );

    // user action: sets grad plans equal to the calc grad plan
    this.actionTaken = this.studentIdsWithCurrGpRegents.length === this.studentIdsWithCalcGpRegents.length;
  }

  private generateFilteredStudentIdBuckets(): object {
    const o = {
      calculatedGpRegents: {},
      currentGpIncomplete: {},
      currentGpRegents: {},
      currentGpOther: {},
    };
    // student is a modified student NOT IStudent
    _.each(this.activeStudentsByCohort, (student: any) => {
      const { studentId, calculatedGradPlan, gradPlan, cohort } = student;
      if (Number(cohort) >= this.superSeniorThreshold) {
        if (calculatedGradPlan === Plan.REGENTS_4_YEAR_AUG.humanName) {
          o.calculatedGpRegents[studentId] = student._id;
          const gradPlanIncomplete = gradPlan === Plan.PLAN_INCOMPLETE.humanName;
          const gradPlanInPast = gradPlan === Plan.PLAN_IN_PAST.humanName;
          if (gradPlanIncomplete || gradPlanInPast) return (o.currentGpIncomplete[studentId] = student._id);
          if (gradPlan === Plan.REGENTS_4_YEAR_AUG.humanName) {
            return (o.currentGpRegents[studentId] = student._id);
          } else return (o.currentGpOther[studentId] = student._id);
        }
      }
    });
    return o;
  }
}
